<template>
  <div class="Content__DocumentEmpty mx-auto px-5 md:px-0">
    <div class="flex items-center justify-between">
      <div class="text-sm md:text-base font-semibold" v-html="text"></div>
      <div>
        <a href="#" @click.stop.prevent="cancel">{{ $t('show whole document') }}</a>
      </div>
    </div>
  </div>
</template>

<script>
import { mapStores } from 'pinia'
import useBcSearchStore from '@/frontapp/store/bcSearch'

export default {
  props: {
    foundResults: {
      type: Number,
      required: true,
    }
  },
  computed: {
    ...mapStores(useBcSearchStore),
    text() {
      return this.$t('Found %foundResults% elements for query: <span class="text-bc-blue">%query%</span>', {
        foundResults: this.foundResults,
        query: this.query
      })
    },
    query: {
      get() {
        return this.bcSearchStore.query
      },
      set(val) {
        this.bcSearchStore.query = val ? val : null
      }
    },
  },
  methods: {
    cancel() {
      this.bcSearchStore.clear()
    }
  }
}
</script>